import { render, staticRenderFns } from "./ChooseAccount.vue?vue&type=template&id=40bc8020"
import script from "./ChooseAccount.vue?vue&type=script&lang=js"
export * from "./ChooseAccount.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports